
import { computed, defineComponent } from 'vue'
import { includes } from 'lodash-es'

export enum BaseCardThemes {primary = 'primary', secondary = 'secondary'}

export default defineComponent({
  props: {
    theme: { type: String, default: 'primary', validator: (value: string) => includes(BaseCardThemes, value) }
  },
  setup(props) {
    const themeClass = computed(() => `base-card--${props.theme}`)

    return {
      themeClass
    }
  }
})

